"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATIONS_CLEAR_FILTERS = exports.LOCATIONS_GEOCODING = exports.LOCATIONS_UPDATE_ORGID = exports.LOCATIONS_UPDATE_FILTER = exports.LOCATION_PAGE_VIEW = exports.LOCATION_ERROR = exports.LOCATION_SUCCESS = exports.LOCATION_LOADING = exports.LOCATIONS_ERROR = exports.LOCATIONS_SUCCESS = exports.LOCATIONS_LOADING = void 0;
var LOCATIONS_LOADING = "LOCATIONS_LOADING";
exports.LOCATIONS_LOADING = LOCATIONS_LOADING;
var LOCATIONS_SUCCESS = "LOCATIONS_SUCCESS";
exports.LOCATIONS_SUCCESS = LOCATIONS_SUCCESS;
var LOCATIONS_ERROR = "LOCATIONS_ERROR";
exports.LOCATIONS_ERROR = LOCATIONS_ERROR;
var LOCATION_LOADING = "LOCATION_LOADING";
exports.LOCATION_LOADING = LOCATION_LOADING;
var LOCATION_SUCCESS = "LOCATION_SUCCESS";
exports.LOCATION_SUCCESS = LOCATION_SUCCESS;
var LOCATION_ERROR = "LOCATION_ERROR";
exports.LOCATION_ERROR = LOCATION_ERROR;
var LOCATION_PAGE_VIEW = "LOCATION_PAGE_VIEW";
exports.LOCATION_PAGE_VIEW = LOCATION_PAGE_VIEW;
var LOCATIONS_UPDATE_FILTER = "LOCATIONS_UPDATE_FILTER";
exports.LOCATIONS_UPDATE_FILTER = LOCATIONS_UPDATE_FILTER;
var LOCATIONS_UPDATE_ORGID = "LOCATIONS_UPDATE_ORGID";
exports.LOCATIONS_UPDATE_ORGID = LOCATIONS_UPDATE_ORGID;
var LOCATIONS_GEOCODING = "LOCATIONS_GEOCODING";
exports.LOCATIONS_GEOCODING = LOCATIONS_GEOCODING;
var LOCATIONS_CLEAR_FILTERS = "LOCATIONS_CLEAR_FILTERS";
exports.LOCATIONS_CLEAR_FILTERS = LOCATIONS_CLEAR_FILTERS;